<template>
    <div class="row">
      <div class="col-md-8">
        <card>
          <form class="form-horizontal" @submit.prevent="addItem">
            <h5 slot="header" class="card-title ml-7">
              Add Lobby Drink
            </h5>
            <br>
            <div class="row">
              <label class="col-md-3 col-form-label">Drink Name</label>
              <div class="col-md-9">
                <ValidationProvider
                    name="DrinkName"
                    rules="required"
                    v-slot="{ passed, failed }"
                >
                    <fg-input
                    :error="failed ? 'Drink Name is required': null"
                    :hasSuccess="passed"
                    v-model="form.DrinkName"
                    placeholder="Name"
                    type="text"
                    required
                    ></fg-input>
                </ValidationProvider>
              </div>

              <label class="col-md-3 col-form-label">Drink Type</label>
              <div class="col-md-9">
                <fg-input>
                  <el-select class="select-info"
                             size="large"
                             placeholder="Drink Type"
                             v-model="selects.simple">
                    <el-option v-for="option in selects.drink"
                               class="select-info"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
              </div>

              <label class="col-md-3 col-form-label">Drink Ingredients</label>
              <div class="col-md-9">
                <!-- <fg-input
                  v-model="form.Drink"
                  placeholder="Ingredients"
                  type="text"
                ></fg-input> -->
                <textarea class="form-control mb-2" v-model="form.DrinkIngredients" placeholder="Drink Ingredients" rows="3"></textarea>

              </div>

              <label class="col-md-3 col-form-label">Drink Price</label>
              <div class="col-md-9">
                <fg-input
                  v-model="form.DrinkPrice"
                  placeholder="Price"
                  type="number" step="any"
                ></fg-input>
              </div>  
              </div>  
              
             <!-- <div class="row mb-3">
            <label class="col-md-3 col-form-label">Upload Image</label>
            <div class="col-md-9">
              <label for="imageUpload" class="img">
                <span v-if="!imageUrl">Choose Image</span>
                <img v-if="!imageUrl" src="../../../../../public/static/img/drink.jpg" width="200" alt="">
                <input type="file" id="imageUpload" @change="onFileChange" accept="image/*" hidden />
              </label>
              
              <div v-if="imageUrl" class="mt-3">
                <img :src="imageUrl" alt="Preview" class="img-thumbnail" style="max-width: 300px;" />
                <br>
                <p-button type="info outline mt-2"  @click="removeImage" outline>
                <i slot="label" class="nc-icon nc-simple-remove"></i> Delete Image
              </p-button>
              </div>
            </div>
          </div> -->
  
            <div slot="footer" class="row">
              <label class="col-md-3"></label>
              <div class="col-md-9 d-flex justify-content-end">
                <p-button type="success" round @click="addItem" :disabled="isSubmitting" >
                  Add Drink
                </p-button>
              </div>
            </div>
          </form>
        </card>
      </div>
    </div>
  </template>
  
  <script>
  import { Select, Option} from 'element-ui'
  import { Card } from 'src/components/UIComponents';
  import { getAuth, updatePassword, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth';
  import { extend } from "vee-validate";
  import { required } from "vee-validate/dist/rules";
  import Swal from 'sweetalert2';
  import {Button} from 'src/components/UIComponents';


  //Firebase
  import { collection, addDoc, doc, setDoc, query, where, getDocs, orderBy } from "firebase/firestore";

  import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
  import { db } from "@/firebase"; // Import Firestore instance
  import { storage } from "@/firebase"; // Import Firebase storage instance


 extend("required", required);

  export default {
    components: {
      [Button.name]: Button,
      Card,
      [Option.name]: Option,
      [Select.name]: Select,
    },
    data() {
      return {
        isSubmitting: false,
        imageUrl: null,
        form: {
          oldPassword: '',
          newPassword: '',
          confirmPassword: '',
        },
        selects: {
          simple: 'HOT DRINK',
        drink: []
        },
      };
    },
    async mounted() {
      this.fetchCategories();
    },
    methods: {
      async fetchCategories() {
        try {
          const q = query(
            collection(db, "CategoryOptions"),
            where("type", "==", "LobbyDrink")
          );
          const querySnapshot = await getDocs(q);
          const options = querySnapshot.docs.map(doc => ({
            value: doc.data().name,
            label: doc.data().name
          }));
          this.selects.drink = options.sort((a, b) => a.label.localeCompare(b.label));
          if (this.selects.drink.length > 0 && !this.selects.simple) {
            this.selects.simple = this.selects.drink[0].value;
          }
        } catch (error) {
          console.error("Error fetching categories:", error);
        }
      },
        onFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.file = file;
                this.imageUrl = URL.createObjectURL(file);
            }
        },
        removeImage() {
            this.imageUrl = null;
            this.file = null;
        },
        async addItem() {
        try {
            this.isSubmitting = true; 

            // Upload the image to Firebase Storage
            // const storageRef = ref(storage, `drinkImages/${this.file.name}`);
            // const snapshot = await uploadBytes(storageRef, this.file);
            // const imageUrl = await getDownloadURL(snapshot.ref);

            // Set the document with DrinkName as the ID
            const docRef = doc(db, "DrinksMenu", this.form.DrinkName);  // Specify DrinkName as document ID
            await setDoc(docRef, {
            DrinkName: this.form.DrinkName,
            DrinkType: this.selects.simple,
            DrinkIngredients: this.form.DrinkIngredients,
            DrinkPrice: this.form.DrinkPrice,
            // PictureURL: imageUrl,  // Storing the uploaded image URL
            createdAt: new Date()
            });

            console.log("Document written with DrinkName as ID:", this.form.DrinkName);

            Swal.mixin({
            customClass: {
                confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
            }).fire({
            title: `Success!`,
            text: "Drink item added successfully!",
            });

            this.$router.replace("/lobbydrink/list");
            this.isSubmitting = false; 
        } catch (error) {
            console.error('Error adding menu:', error.message);
            alert('Error: ' + error.message);
        }
        }
    },
  };
  </script>
  
  <style scoped>
  .img-thumbnail {
    border: 2px solid #ddd;
    border-radius: 5px;
    padding: 5px;
  }
  </style>